import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect } from "react";
import { searchApprovalGroupsCompanies } from "../store/slices/userRequests";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store";

interface MySelectCompanyProps {
    includeAllCompaniesOption?: boolean;
    allCompaniesOptionValue?: string;
    rucSelected: string;
    setRucSelected: (ruc: string) => void;
    // setCompanySelectedData?: 
    minWidth?: string;
}

const MySelectCompany = ({
    includeAllCompaniesOption,
    allCompaniesOptionValue,
    rucSelected, 
    setRucSelected,
    minWidth,
}: MySelectCompanyProps) => {

    const dispatch = useDispatch<AppDispatch>();
    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const {companies, companiesIsLoading,} = useSelector((state: RootState) => state.userRequests).approvalGroups;

    useEffect(() => {
        if (!connectionId || !companyselected?.Token || companiesIsLoading || companies.length) {
            return;
        }
        dispatch(searchApprovalGroupsCompanies());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected?.Token, connectionId])

    useEffect(() => {
        if (companiesIsLoading || rucSelected) {
            return
        }
        setRucSelected(
            allCompaniesOptionValue !== undefined
                ? allCompaniesOptionValue
                : companies.length
                    ? companies[0].RUC
                    : ""
        )
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companiesIsLoading, companies])

    if (companiesIsLoading) {
        return <></>;
    }

    return (
        <Grid item>
            <FormControl style={{minWidth: minWidth || "15rem"}}>
                <InputLabel id="select-option-label">Empresa</InputLabel>
                <Select
                    labelId="select-option-label"
                    id="select-option"
                    label={"Empresa"}
                    onChange={(event: { target: { value: string } }) => {
                        const value = event.target.value;
                        setRucSelected(value);
                    }}
                    value={rucSelected}
                    style={{height: "2.5rem", border: "none", backgroundColor: "white"}}
                >
                    {includeAllCompaniesOption && 
                        <MenuItem 
                            value={allCompaniesOptionValue || ""}
                        >
                            Todas las empresas
                        </MenuItem>
                    }
                    {companies?.map((item, i) => (
                        <MenuItem
                            key={i} 
                            value={item.RUC}
                        >
                            {item.Descripcion}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Grid>
    )
}

export default MySelectCompany;